function isIterableSet(iterable) {
  return iterable instanceof Set;
}

function isNonNullish(value) {
  return value !== null && value !== undefined;
}

function isFunction(func) {
  return typeof func === 'function';
}

export { isFunction, isIterableSet, isNonNullish };